// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg fill=%27none%27 stroke=%27%2394a3b8%27 stroke-width=%272%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AddProduct.css - Compact & Professional Design */

.add-product-container {
  max-width: 1000px;
  margin: 20px auto;
  padding: 20px;
  background: linear-gradient(180deg, #0f172a, #020617);
  border-radius: 12px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5);
  color: #fff;
  font-family: 'Inter', 'Segoe UI', sans-serif;
}

/* ===== Form Wrapper ===== */
.add-product-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ===== Section ===== */
.form-section {
  padding: 16px;
  background: #0b1120;
  border-radius: 10px;
  border: 1px solid #1e293b;
}

.form-section h3 {
  font-size: 14px;
  margin-bottom: 12px;
  color: #f1f5f9;
  border-left: 3px solid #3b82f6;
  padding-left: 8px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

/* ===== Nested Section ===== */
.form-section .form-section {
  margin-top: 12px;
  background: #020617;
  border: 1px dashed #334155;
}

/* ===== Grid ===== */
.form-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

/* ===== Labels ===== */
.add-product-form label {
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  margin-bottom: 3px;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* ===== Inputs & Select ===== */
.add-product-form input,
.add-product-form select,
.add-product-form textarea {
  width: 100%;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #334155;
  font-size: 12px;
  background: #020617;
  color: #fff;
  height: 34px;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.add-product-form textarea {
  min-height: 70px;
  resize: vertical;
  padding: 8px 10px;
}

.add-product-form input:hover,
.add-product-form select:hover,
.add-product-form textarea:hover {
  border-color: #3b82f6;
}

.add-product-form input:focus,
.add-product-form select:focus,
.add-product-form textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
  outline: none;
}

/* ===== Select Arrow ===== */
select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
}

/* ===== Custom Dropdown ===== */
.custom-dropdown-container {
  position: relative;
  width: 100%;
}

.custom-dropdown {
  position: relative;
  width: 100%;
}

.custom-dropdown-select {
  width: 100%;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #334155;
  font-size: 12px;
  background: #020617;
  color: #fff;
  height: 34px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.custom-dropdown-select::after {
  content: '';
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #94a3b8;
}

.custom-dropdown-select:hover {
  border-color: #3b82f6;
}

.custom-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 4px;
  border: 1px solid #334155;
  border-radius: 6px;
  background: #0b1120;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
  z-index: 1000;
  max-height: 260px;
  overflow: hidden;
}

.custom-dropdown-search {
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-bottom: 1px solid #334155;
  outline: none;
  background: #020617;
  color: #fff;
  font-size: 12px;
}

.custom-dropdown-search::placeholder {
  color: #475569;
}

.custom-dropdown-options {
  max-height: 180px;
  overflow-y: auto;
}

.custom-dropdown-option {
  padding: 8px 10px;
  cursor: pointer;
  color: #fff;
  font-size: 12px;
  transition: background 0.2s;
}

.custom-dropdown-option:hover {
  background: #1e293b;
}

.custom-dropdown-option.other-option {
  border-top: 1px solid #334155;
  color: #3b82f6;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.custom-dropdown-other-input {
  padding: 10px;
  border-top: 1px solid #334155;
}

.other-text-input {
  width: 100%;
  padding: 6px 8px;
  margin-bottom: 6px;
  border: 1px solid #334155;
  border-radius: 4px;
  background: #020617;
  color: #fff;
  font-size: 12px;
}

.other-text-input:focus {
  border-color: #3b82f6;
  outline: none;
}

.other-save-btn {
  width: 100%;
  padding: 6px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  transition: all 0.2s;
}

.other-save-btn:hover {
  opacity: 0.9;
}

.custom-dropdown-option.disabled {
  color: #475569;
  cursor: default;
}

/* ===== Image Upload ===== */
.image-upload-box {
  position: relative;
  border: 2px dashed #334155;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  cursor: pointer;
  background: #020617;
  /* transition: all 0.2s ease; */
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* transition: border-color 0.2s ease; */
}

.image-upload-box:hover {
  border-color: #3b82f6;
  background: #020617;
}

.image-upload-box span {
  font-size: 12px;
  color: #64748b;
  transition: color 0.2s ease;
}

.image-upload-box input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.image-upload-box img.preview-image {
  max-width: 140px;
  max-height: 140px;
  border-radius: 6px;
  display: block;
  margin: auto;
  object-fit: cover;
}

.image-upload-box.small {
  padding: 12px;
  min-height: 80px;
  /* margin-top: 0px; */
}

.image-upload-box:hover span {
  color: #64748b;
  /* Same color on hover - no change */
}

/* ===== Quantity Cards ===== */
.quantity-section {
  grid-column: 1 / -1;
  /* margin-bottom: 8px; */
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* Left align */
  width: 100%;
}

.quantity-cards {
  display: flex;
  gap: 6px;
  /* margin-bottom: 8px; */
  max-width: 50px;
}

.quantity-card {
  flex: 1 1;
  /* display: flex; */
  align-items: center;
  /* justify-content: center; */
  padding: 4px 8px;
  background: #020617;
  border: 1px solid #334155;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  /* min-width: 50px; */
}

.quantity-card:hover {
  border-color: #3b82f6;
}

.quantity-card.active {
  border-color: #3b82f6;
  background: #1e293b;
}

.quantity-label {
  font-size: 11px;
  font-weight: 500;
  color: #fff;
  text-align: center;
}

.quantity-input {
  width: 100%;
  max-width: 300px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #334155;
  background: #020617;
  color: #fff;
  font-size: 12px;
  height: 34px;
  box-sizing: border-box;
}

/* ===== Difference Section ===== */
.difference-container {
  margin-top: 8px;
}

.difference-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  max-width: 180px;
  border: 1px solid #334155;
  border-radius: 6px;
  overflow: hidden;
  background: #020617;
}

.difference-box input {
  flex: 1 1;
  text-align: center;
  border: none;
  outline: none;
  font-weight: 500;
  background: #0f172a;
  color: white;
  height: 32px;
  padding: 0;
  font-size: 12px;
  margin-top: 20px;
}

.difference-box button {
  width: 32px;
  height: 32px;
  border: none;
  background: #1e293b;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.difference-box button:hover {
  background: #3b82f6;
}

/* ===== Dimensions Grid ===== */
.dimensions-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

@media (max-width: 900px) {
  .dimensions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .dimensions-grid {
    grid-template-columns: 1fr;
  }
}

.dimension-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.dimension-item label {
  font-size: 10px;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 0;
}

/* ===== Toggle Buttons ===== */
.toggle-buttons {
  display: flex;
  gap: 6px;
  margin-top: 6px;
  /* max-width: 350px; */
}

.toggle-buttons button {
  flex: 1 1;
  padding: 10px 16px;
  border-radius: 6px;
  border: 1px solid #334155;
  background: #020617;
  color: #94a3b8;
  font-weight: 500;
  font-size: 11px;
  cursor: pointer;
  transition: 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.toggle-buttons button:hover {
  border-color: #3b82f6;
}

.toggle-buttons button.active-btn {
  background: #020617;
  color: #fff;
  border: 1px solid #3b82f6;
}

/* ===== Description Textarea ===== */
.description-container {
  width: 100%;
}

.description-textarea {
  width: 100%;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #334155;
  background: #020617;
  color: #fff;
  font-size: 12px;
  resize: vertical;
  min-height: 70px;
  font-family: inherit;
  line-height: 1.4;
  box-sizing: border-box;
}

.description-textarea:focus {
  border-color: #3b82f6;
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

.description-textarea::placeholder {
  color: #475569;
  font-size: 11px;
}

/* ===== Submit Button ===== */
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
}

.cancel-btn {
  background: transparent;
  color: #e2e8f0;
  border: 1px solid #334155;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
}

.cancel-btn:hover {
  border-color: #3b82f6;
  color: #fff;
}

.submit-btn {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.submit-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 5px 15px rgba(59, 130, 246, 0.3);
}

.submit-btn:active {
  transform: scale(0.98);
}

/* ===== Utility Classes ===== */
.full-width {
  grid-column: 1 / -1;
}

/* ===== Purity Fields Grid ===== */
.form-grid .form-grid {
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 8px;
  background: #020617;
  border-radius: 6px;
  margin-top: 4px;
}

/* ===== Custom Select Styling ===== */
.custom-select {
  width: 100%;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #334155;
  font-size: 12px;
  background: #020617;
  color: #fff;
  height: 34px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
}

.custom-select:hover {
  border-color: #3b82f6;
}

.custom-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
  outline: none;
}

/* ===== Responsive Adjustments ===== */
@media (max-width: 768px) {
  .add-product-container {
    margin: 10px;
    padding: 15px;
  }

  .dimensions-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .form-grid .form-grid {
    grid-template-columns: 1fr;
  }

  .quantity-cards,
  .quantity-input {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Products/AddProduct/AddProduct.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,qDAAqD;EACrD,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,4CAA4C;AAC9C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;;;EAGE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,yDAA+J;EAC/J,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,qCAAqC;EACrC,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yDAA+J;EAC/J,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* AddProduct.css - Compact & Professional Design */\n\n.add-product-container {\n  max-width: 1000px;\n  margin: 20px auto;\n  padding: 20px;\n  background: linear-gradient(180deg, #0f172a, #020617);\n  border-radius: 12px;\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5);\n  color: #fff;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n}\n\n/* ===== Form Wrapper ===== */\n.add-product-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ===== Section ===== */\n.form-section {\n  padding: 16px;\n  background: #0b1120;\n  border-radius: 10px;\n  border: 1px solid #1e293b;\n}\n\n.form-section h3 {\n  font-size: 14px;\n  margin-bottom: 12px;\n  color: #f1f5f9;\n  border-left: 3px solid #3b82f6;\n  padding-left: 8px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n/* ===== Nested Section ===== */\n.form-section .form-section {\n  margin-top: 12px;\n  background: #020617;\n  border: 1px dashed #334155;\n}\n\n/* ===== Grid ===== */\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n@media (max-width: 900px) {\n  .form-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ===== Labels ===== */\n.add-product-form label {\n  font-size: 11px;\n  font-weight: 500;\n  color: #94a3b8;\n  margin-bottom: 3px;\n  display: block;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n/* ===== Inputs & Select ===== */\n.add-product-form input,\n.add-product-form select,\n.add-product-form textarea {\n  width: 100%;\n  padding: 6px 10px;\n  border-radius: 6px;\n  border: 1px solid #334155;\n  font-size: 12px;\n  background: #020617;\n  color: #fff;\n  height: 34px;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.add-product-form textarea {\n  min-height: 70px;\n  resize: vertical;\n  padding: 8px 10px;\n}\n\n.add-product-form input:hover,\n.add-product-form select:hover,\n.add-product-form textarea:hover {\n  border-color: #3b82f6;\n}\n\n.add-product-form input:focus,\n.add-product-form select:focus,\n.add-product-form textarea:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n  outline: none;\n}\n\n/* ===== Select Arrow ===== */\nselect {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg fill='none' stroke='%2394a3b8' stroke-width='2' viewBox='0 0 24 24'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 12px;\n}\n\n/* ===== Custom Dropdown ===== */\n.custom-dropdown-container {\n  position: relative;\n  width: 100%;\n}\n\n.custom-dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.custom-dropdown-select {\n  width: 100%;\n  padding: 6px 10px;\n  border-radius: 6px;\n  border: 1px solid #334155;\n  font-size: 12px;\n  background: #020617;\n  color: #fff;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.custom-dropdown-select::after {\n  content: '';\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid #94a3b8;\n}\n\n.custom-dropdown-select:hover {\n  border-color: #3b82f6;\n}\n\n.custom-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  margin-top: 4px;\n  border: 1px solid #334155;\n  border-radius: 6px;\n  background: #0b1120;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  max-height: 260px;\n  overflow: hidden;\n}\n\n.custom-dropdown-search {\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-bottom: 1px solid #334155;\n  outline: none;\n  background: #020617;\n  color: #fff;\n  font-size: 12px;\n}\n\n.custom-dropdown-search::placeholder {\n  color: #475569;\n}\n\n.custom-dropdown-options {\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.custom-dropdown-option {\n  padding: 8px 10px;\n  cursor: pointer;\n  color: #fff;\n  font-size: 12px;\n  transition: background 0.2s;\n}\n\n.custom-dropdown-option:hover {\n  background: #1e293b;\n}\n\n.custom-dropdown-option.other-option {\n  border-top: 1px solid #334155;\n  color: #3b82f6;\n  font-weight: 500;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.custom-dropdown-other-input {\n  padding: 10px;\n  border-top: 1px solid #334155;\n}\n\n.other-text-input {\n  width: 100%;\n  padding: 6px 8px;\n  margin-bottom: 6px;\n  border: 1px solid #334155;\n  border-radius: 4px;\n  background: #020617;\n  color: #fff;\n  font-size: 12px;\n}\n\n.other-text-input:focus {\n  border-color: #3b82f6;\n  outline: none;\n}\n\n.other-save-btn {\n  width: 100%;\n  padding: 6px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.other-save-btn:hover {\n  opacity: 0.9;\n}\n\n.custom-dropdown-option.disabled {\n  color: #475569;\n  cursor: default;\n}\n\n/* ===== Image Upload ===== */\n.image-upload-box {\n  position: relative;\n  border: 2px dashed #334155;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n  cursor: pointer;\n  background: #020617;\n  /* transition: all 0.2s ease; */\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* transition: border-color 0.2s ease; */\n}\n\n.image-upload-box:hover {\n  border-color: #3b82f6;\n  background: #020617;\n}\n\n.image-upload-box span {\n  font-size: 12px;\n  color: #64748b;\n  transition: color 0.2s ease;\n}\n\n.image-upload-box input {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n.image-upload-box img.preview-image {\n  max-width: 140px;\n  max-height: 140px;\n  border-radius: 6px;\n  display: block;\n  margin: auto;\n  object-fit: cover;\n}\n\n.image-upload-box.small {\n  padding: 12px;\n  min-height: 80px;\n  /* margin-top: 0px; */\n}\n\n.image-upload-box:hover span {\n  color: #64748b;\n  /* Same color on hover - no change */\n}\n\n/* ===== Quantity Cards ===== */\n.quantity-section {\n  grid-column: 1 / -1;\n  /* margin-bottom: 8px; */\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  /* Left align */\n  width: 100%;\n}\n\n.quantity-cards {\n  display: flex;\n  gap: 6px;\n  /* margin-bottom: 8px; */\n  max-width: 50px;\n}\n\n.quantity-card {\n  flex: 1;\n  /* display: flex; */\n  align-items: center;\n  /* justify-content: center; */\n  padding: 4px 8px;\n  background: #020617;\n  border: 1px solid #334155;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  /* min-width: 50px; */\n}\n\n.quantity-card:hover {\n  border-color: #3b82f6;\n}\n\n.quantity-card.active {\n  border-color: #3b82f6;\n  background: #1e293b;\n}\n\n.quantity-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: #fff;\n  text-align: center;\n}\n\n.quantity-input {\n  width: 100%;\n  max-width: 300px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  border: 1px solid #334155;\n  background: #020617;\n  color: #fff;\n  font-size: 12px;\n  height: 34px;\n  box-sizing: border-box;\n}\n\n/* ===== Difference Section ===== */\n.difference-container {\n  margin-top: 8px;\n}\n\n.difference-box {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  max-width: 180px;\n  border: 1px solid #334155;\n  border-radius: 6px;\n  overflow: hidden;\n  background: #020617;\n}\n\n.difference-box input {\n  flex: 1;\n  text-align: center;\n  border: none;\n  outline: none;\n  font-weight: 500;\n  background: #0f172a;\n  color: white;\n  height: 32px;\n  padding: 0;\n  font-size: 12px;\n  margin-top: 20px;\n}\n\n.difference-box button {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: #1e293b;\n  color: white;\n  font-size: 14px;\n  cursor: pointer;\n  transition: 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.difference-box button:hover {\n  background: #3b82f6;\n}\n\n/* ===== Dimensions Grid ===== */\n.dimensions-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n}\n\n@media (max-width: 900px) {\n  .dimensions-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .dimensions-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.dimension-item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.dimension-item label {\n  font-size: 10px;\n  font-weight: 500;\n  color: #64748b;\n  margin-bottom: 0;\n}\n\n/* ===== Toggle Buttons ===== */\n.toggle-buttons {\n  display: flex;\n  gap: 6px;\n  margin-top: 6px;\n  /* max-width: 350px; */\n}\n\n.toggle-buttons button {\n  flex: 1;\n  padding: 10px 16px;\n  border-radius: 6px;\n  border: 1px solid #334155;\n  background: #020617;\n  color: #94a3b8;\n  font-weight: 500;\n  font-size: 11px;\n  cursor: pointer;\n  transition: 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.toggle-buttons button:hover {\n  border-color: #3b82f6;\n}\n\n.toggle-buttons button.active-btn {\n  background: #020617;\n  color: #fff;\n  border: 1px solid #3b82f6;\n}\n\n/* ===== Description Textarea ===== */\n.description-container {\n  width: 100%;\n}\n\n.description-textarea {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid #334155;\n  background: #020617;\n  color: #fff;\n  font-size: 12px;\n  resize: vertical;\n  min-height: 70px;\n  font-family: inherit;\n  line-height: 1.4;\n  box-sizing: border-box;\n}\n\n.description-textarea:focus {\n  border-color: #3b82f6;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n}\n\n.description-textarea::placeholder {\n  color: #475569;\n  font-size: 11px;\n}\n\n/* ===== Submit Button ===== */\n.button-container {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.cancel-btn {\n  background: transparent;\n  color: #e2e8f0;\n  border: 1px solid #334155;\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.cancel-btn:hover {\n  border-color: #3b82f6;\n  color: #fff;\n}\n\n.submit-btn {\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  color: white;\n  padding: 8px 18px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.submit-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 5px 15px rgba(59, 130, 246, 0.3);\n}\n\n.submit-btn:active {\n  transform: scale(0.98);\n}\n\n/* ===== Utility Classes ===== */\n.full-width {\n  grid-column: 1 / -1;\n}\n\n/* ===== Purity Fields Grid ===== */\n.form-grid .form-grid {\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n  padding: 8px;\n  background: #020617;\n  border-radius: 6px;\n  margin-top: 4px;\n}\n\n/* ===== Custom Select Styling ===== */\n.custom-select {\n  width: 100%;\n  padding: 6px 10px;\n  border-radius: 6px;\n  border: 1px solid #334155;\n  font-size: 12px;\n  background: #020617;\n  color: #fff;\n  height: 34px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg fill='none' stroke='%2394a3b8' stroke-width='2' viewBox='0 0 24 24'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 12px;\n}\n\n.custom-select:hover {\n  border-color: #3b82f6;\n}\n\n.custom-select:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n  outline: none;\n}\n\n/* ===== Responsive Adjustments ===== */\n@media (max-width: 768px) {\n  .add-product-container {\n    margin: 10px;\n    padding: 15px;\n  }\n\n  .dimensions-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .form-grid .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .quantity-cards,\n  .quantity-input {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
